import React, { memo, useCallback, useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import Avatar from '@sharedCR/common/Avatar';
import PropTypes from 'prop-types';

import { getPersonInitials } from 'utils/loanApplication';

import { getContactDisplayName } from '../../../../crmContact.utils';
import { getContactAvatarStyles } from '../../../CrmContactSection.styles';
import { getContactSubtitle } from '../../../CrmContactSection.utils';

import { nameStyles, rowStyles, subtitleStyles } from './ContactResultRow.styles';

const AVATAR_SIZE = 32;

const ContactResultRow = ({ contact, onPick }) => {
  const name = getContactDisplayName(contact);
  const subtitle = getContactSubtitle(contact);

  const onClick = useCallback(() => onPick(contact), [onPick, contact]);

  const avatarStyles = useMemo(
    () => getContactAvatarStyles({ contact, size: AVATAR_SIZE }),
    [contact],
  );

  return (
    <Box component="button" sx={rowStyles} type="button" onClick={onClick}>
      <Avatar customStyles={avatarStyles} initials={getPersonInitials(contact)} />
      <Box minWidth={0}>
        <Typography sx={nameStyles} variant="medium14">
          {name}
        </Typography>
        {subtitle && (
          <Typography sx={subtitleStyles} variant="regular12">
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

ContactResultRow.propTypes = {
  contact: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }).isRequired,
  onPick: PropTypes.func.isRequired,
};

export default memo(ContactResultRow);
